import React, { useState, useEffect } from "react";
import classes from "./styles.module.scss";
import Paginations from "@/components/Paginations";
import ResourceHero from "@/components/ResourceHero";
import Breadcrumb from "@/components/Breadcrumb";
import Hero2 from "@/components/Hero2";
import SeoHead from "@/components/SeoHead";
import { blog_helper } from "@/helpers/blog_helper";
import { Cookies } from "@/components";

export default function BlogsPage({all_resources, random_resource}) {

  var defaultTab = null;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    defaultTab = urlParams.get('tab');
    if (defaultTab) {
      setSelectedTab(defaultTab)
    }
  }, [])

 
  const filterType = ["Show All", "Blog"];

  const [selectedTab, setSelectedTab] = useState(defaultTab || "Show All");

  const filteredResources =
    selectedTab === "Show All"
      ? all_resources
      : all_resources.filter((resource) => resource.category?.toLowerCase() === selectedTab.toLowerCase());

  const handleTabClick = (type) => {
    setSelectedTab(type);
  };

  return (
    <>
      <div style={{marginTop: '200px'}} className={classes.resource}>
        <SeoHead
            page_name={`Blog | Xcede Group`}
            canonical_link={`https://www.xcedegroup.com/blog`}
          />
        <Breadcrumb label="News"/>
        <div style={{paddingTop: '40px'}}>
          <Hero2 highlight="News" split={false}/>        
        </div>
        <div style={{padding: '60px 0'}}>
          <ResourceHero resource={random_resource}/>
        </div>
        <div className={classes.filters}>
          <div className={classes.label}>categories</div>
          <div className={classes.tab}>
            {filterType.map((type) => (
              <div
                key={type}
                className={`${classes.filter} ${selectedTab.toLowerCase() === type.toLowerCase() ? classes.active : ""}`}
                onClick={() => handleTabClick(type)}
              >
                {type}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Paginations resources={filteredResources} />
      
    </>
  );
}

export async function getStaticProps({}) {
  const all_resources = blog_helper.fetch();
  const [random_resource] = all_resources;
  
  return {
    props: {
      all_resources,
      random_resource
    },
  };
}
